import { createAction, props } from '@ngrx/store';
import { PreQualificationApplicationRequest, PreQualificationApplicationResponse, PreQualificationApplicationsPage } from '../../models/prequal.model';

export const submitPreQualApplication = createAction(
  '[PreQual] Submit Application',
  props<{ data: PreQualificationApplicationRequest }>()
);

export const submitPreQualApplicationSuccess = createAction(
  '[PreQual] Submit Application Success',
  props<{ application: PreQualificationApplicationResponse }>()
);

export const submitPreQualApplicationFailure = createAction(
  '[PreQual] Submit Application Failure',
  props<{ error: string }>()
);

export const getPreQualApplications = createAction(
  '[PreQual] Get Applications',
  props<{ pageNumber?: number; pageSize?: number }>()
);

export const getPreQualApplicationsSuccess = createAction(
  '[PreQual] Get Applications Success',
  props<{ page: PreQualificationApplicationsPage }>()
);

export const getPreQualApplicationsFailure = createAction(
  '[PreQual] Get Applications Failure',
  props<{ error: string }>()
);

export const getPreQualApplicationById = createAction(
  '[PreQual] Get Application By Id',
  props<{ id: number }>()
);

export const getPreQualApplicationByIdSuccess = createAction(
  '[PreQual] Get Application By Id Success',
  props<{ application: PreQualificationApplicationResponse }>()
);

export const getPreQualApplicationByIdFailure = createAction(
  '[PreQual] Get Application By Id Failure',
  props<{ error: string }>()
);

export const resetPreQualState = createAction('[PreQual] Reset State');